// extracted by mini-css-extract-plugin
export default {"container":"calendarInput_container__nf8Vp","closeIcon":"calendarInput_closeIcon__2oBa4"};